import { AxiosResponse } from 'axios';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { Configuration, VendorSearchDTO, CreateVendorDto, UpdateVendorDto, VendorsApi, VendorSearchResponseDto} from '@inosio/payments-sdk';
import {
  getFetchingVendorsData,
  setFetchingVendorsData,
  getFetchingVendorsDataFailed,
  getCreatingVendor,
  setCreatingVendor,
  getCreatingVendorFailed,
  getUpdatingVendor,
  setUpdatingVendor,
  getUpdatingVendorFailed,
  deleteVendorUser,
  handleDeleteVendorUserSuccess,
  handleDeleteVendorUserFailed,
} from './vendorsSlice';
import { IpaUserExtended, selectCurrentUser } from '../../../shared/sagas/auth/authSlice';

const { REACT_APP_IPA_BASE_PATH } = process.env;
const apiConfig = new Configuration({ basePath: REACT_APP_IPA_BASE_PATH });

export function requestFetchingVendorsData(access_token: string, VendorDto: VendorSearchDTO) {
  apiConfig.accessToken = access_token;
  const ipaVendorsAPI = new VendorsApi(apiConfig);
  return ipaVendorsAPI.searchVendors(VendorDto);
}

export function requestCreatingVendor(access_token: string, VendorDto: CreateVendorDto) {
  apiConfig.accessToken = access_token;
  const ipaVendorsAPI = new VendorsApi(apiConfig);
  return ipaVendorsAPI.createVendor(VendorDto);
}

export function requestUpdatingVendor(access_token: string, VendorUUID: string, VendorDto: UpdateVendorDto) {
  apiConfig.accessToken = access_token;
  const ipaVendorsAPI = new VendorsApi(apiConfig);
  return ipaVendorsAPI.updateVendor(VendorUUID, VendorDto);
}

export function requestDeleteVendorUser(access_token: string, VendorUuid: string, UserUuid: string) {
  apiConfig.accessToken = access_token;
  const ipaVendorsAPI = new VendorsApi(apiConfig);
  return ipaVendorsAPI.deleteVendorUser(VendorUuid, UserUuid);
}

export function* handleFetchingVendors(action: any) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<VendorSearchResponseDto> = yield call(requestFetchingVendorsData, currentUser.accessToken, action.payload);
    const { data } = response;

    yield put(setFetchingVendorsData(data));
  } catch (error: any) {
    if (error?.response?.data) {
      yield put(
        getFetchingVendorsDataFailed({
          message: error?.response?.data?.message,
          statusCode: error?.response?.data?.statusCode,
        }),
      );
    } else {
      yield put(getFetchingVendorsDataFailed({ ...error }));
    }
  }
}

export function* handleCreatingVendor(action: any) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    yield call(requestCreatingVendor, currentUser.accessToken, action.payload);

    yield put(setCreatingVendor());
  } catch (error: any) {
    if (error?.response?.data) {
      yield put(
        getCreatingVendorFailed({
          message: error?.response?.data?.message,
          statusCode: error?.response?.data?.statusCode,
        }),
      );
    } else {
      yield put(getCreatingVendorFailed({ ...error }));
    }
  }
}

export function* handleUpdatingVendor(action: any) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    yield call(requestUpdatingVendor, currentUser.accessToken, action.payload.Uuid, action.payload);

    yield put(setUpdatingVendor());
  } catch (error: any) {
    if (error?.response?.data) {
      yield put(
        getUpdatingVendorFailed({
          message: error?.response?.data?.message,
          statusCode: error?.response?.data?.statusCode,
        }),
      );
    } else {
      yield put(getUpdatingVendorFailed({ ...error }));
    }
  }
}

export function* handleDeleteVendorUser(action: any) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<any> = yield call(requestDeleteVendorUser, currentUser.accessToken, action.payload.VendorUuid, action.payload.VendorUserUuid);
    const { data } = response;
    yield put(handleDeleteVendorUserSuccess(data));
  } catch (error: any) {
    yield put(
      handleDeleteVendorUserFailed({
        message: error?.response?.data?.message,
        statusCode: error?.response?.data?.statusCode,
      }),
    );
  }
}

export function* vendorsSaga() {
  yield takeLatest(getFetchingVendorsData.type, handleFetchingVendors);
  yield takeLatest(getCreatingVendor.type, handleCreatingVendor);
  yield takeLatest(getUpdatingVendor.type, handleUpdatingVendor);
  yield takeLatest(deleteVendorUser.type, handleDeleteVendorUser);
}
